import React, { useState, useEffect, useRef } from "react";
import Layout from "./Layout";
import "../assets/css/lista.css";
import { FaEye, FaArchive } from "react-icons/fa";
import { getReportList, getExpressList } from "../services/API";
import Select from "react-select";
import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import "alertifyjs/build/css/alertify.css";
import "alertifyjs/build/css/themes/default.css";
import alertify from "alertifyjs";
import { archivationExpress, archivationCST } from "../services/NegativizationService";

const Lista = () => {

    const user = useRef(null);
    const [reportDisplayType, setReportDisplayType] = useState("cst");
    const [busqueda, setBusqueda] = useState("");
    const [tipo, setTipo] = useState("personal");

    const copyCST = useRef([]);
    const [sortConfigCST, setSortConfigCST] = useState({ key: null, direction: "asc" });
    const [filteredParametrosCST, setFilteredParametrosCST] = useState([]);
    const [showModalCST, setShowModalCST] = useState(false);
    const [modalTitleCST, setModalTitleCST] = useState("");
    const [modalOptionsCST, setModalOptionsCST] = useState([]);
    const [filtrosAplicadosCST, setFiltrosAplicadosCST] = useState({});
    const [dateRangeCST, setDateRangeCST] = useState([null, null]);
    const [startDateCST, endDateCST] = dateRangeCST;
    const [searchTermValueCST, setSearchTermValueCST] = useState("");
    const [selectedOptionCST, setSelectedOptionCST] = useState(null);

    // MODIFICACIÓN 1: Cambiado useRef por useState
    const [copyExpress, setCopyExpress] = useState([]);
    const [sortConfigExpress, setSortConfigExpress] = useState({ key: null, direction: "asc" });
    const [filteredParametrosExpress, setFilteredParametrosExpress] = useState([]);
    const [showModalExpress, setShowModalExpress] = useState(false);
    const [modalDataExpress, setModalDataExpress] = useState([]);
    const [isExpressDataReady, setIsExpressDataReady] = useState(false);

    const [showArchiveGroupModalExpress, setShowArchiveGroupModalExpress] = useState(false);
    const [archiveGroupModalDataExpress, setArchiveGroupModalDataExpress] = useState([]);


    const handleSortCST = (key) => {
        let direction = "asc";
        if (sortConfigCST.key === key && sortConfigCST.direction === "asc") {
            direction = "desc";
        }
        setSortConfigCST({ key, direction });
    };

    const sortDataCST = (data, config) => {
        if (!config.key) {
            return data;
        }

        const sortedData = [...data].sort((a, b) => {
            const aValue = a[config.key];
            const bValue = b[config.key];

            if (aValue == null && bValue == null) return 0;
            if (aValue == null) return 1;
            if (bValue == null) return -1;

            if (["fecha", "dateNegativized", "dateUpdated"].includes(config.key)) {
                const dateA = new Date(aValue);
                const dateB = new Date(bValue);

                if (dateA < dateB) {
                    return config.direction === "asc" ? -1 : 1;
                }
                if (dateA > dateB) {
                    return config.direction === "asc" ? 1 : -1;
                }
                return 0;
            } else {
                const strA = String(aValue).toLowerCase();
                const strB = String(bValue).toLowerCase();

                if (strA < strB) {
                    return config.direction === "asc" ? -1 : 1;
                }
                if (strA > strB) {
                    return config.direction === "asc" ? 1 : -1;
                }
                return 0;
            }
        });
        return sortedData;
    };

    const handleApplyFilterCST = () => {
        setShowModalCST(false);
        if (modalTitleCST === "Report Date") {
            setFiltrosAplicadosCST(prev => ({
                ...prev,
                [modalTitleCST]: { start: startDateCST, end: endDateCST }
            }));
        } else if (modalTitleCST === "Customer Search Term") {
            setFiltrosAplicadosCST(prev => ({
                ...prev,
                [modalTitleCST]: { option: selectedOptionCST, value: searchTermValueCST }
            }));
        } else {
            setFiltrosAplicadosCST(prev => ({
                ...prev,
                [modalTitleCST]: selectedOptionCST
            }));
        }
        setSelectedOptionCST(null);
        setSearchTermValueCST("");
        setDateRangeCST([null, null]);
    };

    const aplicarFiltrosCST = (data, filtros) => {
        let datosFiltrados = [...data];

        for (const columna in filtros) {
            if (filtros.hasOwnProperty(columna) && filtros[columna]) {
                if (columna === "Report Date") {
                    const { start, end } = filtros[columna];

                    if (start && end) {
                        const formatDate = (date) => {
                            const year = date.getFullYear();
                            const month = String(date.getMonth() + 1).padStart(2, "0");
                            const day = String(date.getDate()).padStart(2, "0");
                            return `${year}-${month}-${day}`;
                        };

                        const formattedStart = formatDate(start);
                        const formattedEnd = formatDate(end);

                        datosFiltrados = datosFiltrados.filter(item => {
                            if (!item.fecha) return false;
                            return item.fecha >= formattedStart && item.fecha <= formattedEnd;
                        });
                    }
                } else if (columna === "Section") {
                    datosFiltrados = datosFiltrados.filter(item => item.section === filtros[columna]);
                } else if (columna === "Customer Search Term") {
                    const { option, value } = filtros[columna];
                    if (option && value) {
                        datosFiltrados = datosFiltrados.filter(item => {
                            const itemNombreLower = item.nombre.toLowerCase();
                            const valueLower = value.toLowerCase();
                            switch (option) {
                                case "Contiene":
                                    return itemNombreLower.includes(valueLower);
                                case "No Contiene":
                                    return !itemNombreLower.includes(valueLower);
                                case "Es igual a":
                                    return itemNombreLower === valueLower;
                                case "No es igual a":
                                    return itemNombreLower !== valueLower;
                                case "Empieza por":
                                    return itemNombreLower.startsWith(valueLower);
                                case "Termina por":
                                    return itemNombreLower.endsWith(valueLower);
                                default:
                                    return true;
                            }
                        });
                    }
                } else if (columna === "Negativization Mode") {
                    datosFiltrados = datosFiltrados.filter(item => item.negativizationMode === filtros[columna]);
                } else if (columna === "Negative Type") {
                    datosFiltrados = datosFiltrados.filter(item => item.tipo === filtros[columna]);
                }
            }
        }
        return datosFiltrados;
    };

    const opcionesModalCST = {
        "Section": ["RISK", "NEUTRAL", "SECURE"],
        "Negative Type": ["Negative Exact", "Negative Phrase"],
        "Report Date": [],
        "Customer Search Term": [],
        "Negativization Mode": []
    };

    const handleSelectChangeCST = (selected) => {
        const columna = selected?.value;

        if (columna === "Negativization Mode") {
            setModalOptionsCST([
                "Respective Ad Group",
                "All Ad Groups",
                "Select Ad Groups",
                "Respective Campaign",
                "All Campaigns",
                "Select Campaigns",
                "Respective Portfolio",
                "All Portfolios",
                "Select Portfolios",
                "Respective ASIN",
                "All ASINs",
                "Select ASINs"
            ]);
            setShowModalCST(true);
            setModalTitleCST(columna);
        } else if (opcionesModalCST[columna]) {
            setModalTitleCST(columna);
            setModalOptionsCST(opcionesModalCST[columna]);
            setShowModalCST(true);
        } else if (columna === "Report Date" || columna === "Customer Search Term") {
            setModalTitleCST(columna);
            setShowModalCST(true);
        }
    };

    const columnasCST = [
        "Section", "Report Date", "Customer Search Term", "Negativization Mode", "Negative Type"
    ];

    const opcionesFiltradoCST = columnasCST.map((columna) => ({
        label: columna,
        value: columna,
    }));

    const handleVerCST = (param) => {
        alert(`Contenido de la fila:\nCategory: ${param.category}\nSection: ${param.section}\nReport Date: ${param.fecha}\nCustomer Search Term: ${param.nombre}\nNegativization Mode: ${param.negativizationMode}\nNegative Type: ${param.tipo}\nDate Negativized: ${param.dateNegativized}\nDate Updated: ${param.dateUpdated}`);
    };


    const handleSortExpress = (key) => {
        let direction = "asc";
        if (sortConfigExpress.key === key && sortConfigExpress.direction === "asc") {
            direction = "desc";
        }
        setSortConfigExpress({ key, direction });
    };

    const sortExpressData = (data, config) => {
        if (!config.key) {
            return data;
        }

        const sortedData = [...data].sort((a, b) => {
            const aValue = a[config.key];
            const bValue = b[config.key];

            if (aValue == null && bValue == null) return 0;
            if (aValue == null) return 1;
            if (bValue == null) return -1;
            if (["createdAt", "updatedAt"].includes(config.key)) {
                const dateA = new Date(aValue);
                const dateB = new Date(bValue);

                if (dateA < dateB) {
                    return config.direction === "asc" ? -1 : 1;
                }
                if (dateA > dateB) {
                    return config.direction === "asc" ? 1 : -1;
                }
                return 0;
            } else {
                const strA = String(aValue).toLowerCase();
                const strB = String(bValue).toLowerCase();

                if (strA < strB) {
                    return config.direction === "asc" ? -1 : 1;
                }
                if (strA > strB) {
                    return config.direction === "asc" ? 1 : -1;
                }
                return 0;
            }
        });
        return sortedData;
    };

    const handleArchiveCST = (param) => {
        alertify.confirm(
            "Confirmación",
            "¿Estás seguro de que quieres ARCHIVAR el término " + param.nombre + "?",
            async function () {
                const accountID = localStorage.getItem("selectedAccountValue");
                console.log("Archivar:", param.nombre);
                console.log(param.id);
                await archivationCST(param.id, accountID);
                alertify.success("Término archivado.");
                if (accountID) {
                    try {
                        const responseCST = await getReportList(accountID);
                        user.current = responseCST.userId;

                        const formattedDataCST = responseCST.data.map(report => {
                            const formatDateTime = (dateString) => {
                                if (!dateString) return null;
                                const date = new Date(dateString);
                                const yyyy = date.getFullYear();
                                const mm = String(date.getMonth() + 1).padStart(2, "0");
                                const dd = String(date.getDate()).padStart(2, "0");
                                const hh = String(date.getHours()).padStart(2, "0");
                                const min = String(date.getMinutes()).padStart(2, "0");
                                const ss = String(date.getSeconds()).padStart(2, "0");
                                return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
                            };

                            return {
                                ...report,
                                dateNegativized: formatDateTime(report.dateNegativized),
                                dateUpdated: formatDateTime(report.dateUpdated),
                                fecha: report.fecha ? formatDateTime(report.fecha).split(" ")[0] : null
                            };
                        });
                        copyCST.current = formattedDataCST;

                        let processedData = formattedDataCST.filter(item => {
                            if (responseCST.userId === null) return false;
                            return tipo === "personal" ? item.user === responseCST.userId : item.user !== responseCST.userId;
                        });
                        processedData = aplicarFiltrosCST(processedData, filtrosAplicadosCST);
                        if (busqueda) {
                            const searchTerms = busqueda.toLowerCase().split(" ");
                            processedData = processedData.filter(param => {
                                if (typeof param !== "object" || param === null) return false;
                                return Object.values(param).some(value => {
                                    if (value === null || value === undefined) return false;
                                    const stringValue = String(value).toLowerCase();
                                    return searchTerms.every(term => stringValue.includes(term));
                                });
                            });
                        }
                        processedData = sortDataCST(processedData, sortConfigCST);
                        setFilteredParametrosCST(processedData);

                    } catch (error) {
                        console.error("Error re-fetching CST data after archival:", error);
                        alertify.error("Error al actualizar la lista de reportes CST.");
                    }
                }
            },
            function () {
                alertify.error("Operación cancelada.");
            }
        );
    };

    const handleArchiveExpress = (groupData) => {
        if (groupData.customerSearchTerms === "Grupo CST") {
            setArchiveGroupModalDataExpress(groupData.groupData);
            setShowArchiveGroupModalExpress(true);
        } else {
            alertify.confirm(
                "Confirmación",
                "¿Estás seguro de que quieres ARCHIVAR el término " + groupData.customerSearchTerms + "?",
                async function () {
                    const accountID = localStorage.getItem("selectedAccountValue");
                    console.log("Archivar:", groupData.customerSearchTerms);
                    console.log(groupData.ids[0]);
                    await archivationExpress(groupData.ids[0], accountID);
                    alertify.success("Término archivado.");
                    await fetchDataExpress(accountID);
                },
                function () {
                    alertify.error("Operación cancelada.");
                }
            );
        }
    };

    const handleArchiveIndividualExpress = (item) => {
        alertify.confirm(
            "Confirmación",
            `¿Estás seguro de que quieres ARCHIVAR el término "${item.keyword}"?`,
            async function () {
                const accountID = localStorage.getItem("selectedAccountValue");
                console.log("Archivar individual:", item.keyword);
                console.log(item.id);
                await archivationExpress(item.id, accountID);
                alertify.success("Término archivado.");

                setArchiveGroupModalDataExpress(prevData =>
                    prevData.filter(dataItem => dataItem.id !== item.id)
                );
                await fetchDataExpress(accountID);
            },
            function () {
                alertify.error("Operación cancelada.");
            }
        );
    };


    const handleVerMasExpress = (groupData) => {
        setModalDataExpress(groupData);
        setShowModalExpress(true);
    };

    const fetchDataCST = async (accountID) => {
        try {
            const responseCST = await getReportList(accountID);
            user.current = responseCST.userId;

            const formattedDataCST = responseCST.data.map(report => {
                const formatDateTime = (dateString) => {
                    if (!dateString) return null;
                    const date = new Date(dateString);
                    const yyyy = date.getFullYear();
                    const mm = String(date.getMonth() + 1).padStart(2, "0");
                    const dd = String(date.getDate()).padStart(2, "0");
                    const hh = String(date.getHours()).padStart(2, "0");
                    const min = String(date.getMinutes()).padStart(2, "0");
                    const ss = String(date.getSeconds()).padStart(2, "0");
                    return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
                };

                return {
                    ...report,
                    dateNegativized: formatDateTime(report.dateNegativized),
                    dateUpdated: formatDateTime(report.dateUpdated),
                    fecha: report.fecha ? formatDateTime(report.fecha).split(" ")[0] : null
                };
            });
            copyCST.current = formattedDataCST;
            let processedData = formattedDataCST.filter(item => {
                return tipo === "personal" ? item.user === user.current : item.user !== user.current;
            });
            processedData = aplicarFiltrosCST(processedData, filtrosAplicadosCST);
            if (busqueda) {
                const searchTerms = busqueda.toLowerCase().split(" ");
                processedData = processedData.filter(param => {
                    if (typeof param !== "object" || param === null) return false;
                    return Object.values(param).some(value => {
                        if (value === null || value === undefined) return false;
                        const stringValue = String(value).toLowerCase();
                        return searchTerms.every(term => stringValue.includes(term));
                    });
                });
            }
            processedData = sortDataCST(processedData, sortConfigCST);
            setFilteredParametrosCST(processedData);

        } catch (error) {
            console.error("Error fetching CST data:", error);
            alertify.error("Error al cargar reportes CST.");
        }
    };

    const fetchDataExpress = async (accountID) => {
        try {
            const responseExpress = await getExpressList(accountID);
            const destinationMap = {
                1: "Adgroups",
                2: "Campaigns",
                3: "Portafolios",
                4: "Asins"
            };

            const getType = (typeID) => {
                return typeID === 1 ? "Negative Exact" : "Negative Phrase";
            };

            const groupedDataExpress = responseExpress.data.reduce((acc, report) => {
                if (!acc[report.term_id]) {
                    acc[report.term_id] = [];
                }
                acc[report.term_id].push(report);
                return acc;
            }, {});

            const processedDataExpress = Object.values(groupedDataExpress).map(group => {
                const negativeTypes = [...new Set(group.map(item => item.negative_type_id))];
                const idsBD = group.map(item => item.id);
                const keywords = group.map(item => item.keyword);
                const createdDates = group.map(item => item.created_at);
                const updatedDates = group.map(item => item.updated_at);
                const destinationIds = group.map(item => item.destination_id);

                let aggregatedNegativeType = negativeTypes.length > 1 ? "Variado" : getType(negativeTypes[0]);
                if (aggregatedNegativeType === undefined) {
                    aggregatedNegativeType = negativeTypes[0] ? `Unknown Type ID: ${negativeTypes[0]}` : "No definido";
                }

                const firstKeyword = group[0].keyword;
                const allKeywordsSame = keywords.every(kw => kw === firstKeyword);
                let aggregatedKeywords = allKeywordsSame ? firstKeyword : "Grupo CST";

                if (aggregatedKeywords === undefined) {
                    aggregatedKeywords = "No definido";
                }

                const aggregatedCreatedAt = format(new Date(createdDates[0]), "yyyy-MM-dd HH:mm:ss", { locale: es });
                const aggregatedUpdatedAt = format(new Date(updatedDates[0]), "yyyy-MM-dd HH:mm:ss", { locale: es });
                const destinationText = destinationMap[destinationIds[0]] || "No definido";

                const status = Math.random() > 0.5 ? "active" : "paused";

                return {
                    ids: idsBD,
                    term_id: group[0].term_id,
                    negativeType: aggregatedNegativeType,
                    customerSearchTerms: aggregatedKeywords,
                    groupData: group,
                    user: group[0].users_id,
                    createdAt: aggregatedCreatedAt,
                    updatedAt: aggregatedUpdatedAt,
                    destination: destinationText,
                    status: status
                };
            });
            // MODIFICACIÓN 2: Usar setCopyExpress para actualizar el estado
            setCopyExpress(processedDataExpress);
            setIsExpressDataReady(true);
        } catch (error) {
            console.error("Error fetching Express data:", error);
            alertify.error("Error al cargar reportes Express.");
        }
    };

    useEffect(() => {
        const accountID = localStorage.getItem("selectedAccountValue");
        if (!accountID) {
            console.error("No account ID found in localStorage.");
            setFilteredParametrosCST([]);
            setFilteredParametrosExpress([]);
            return;
        }
        fetchDataCST(accountID);
        fetchDataExpress(accountID);
    }, []);

    useEffect(() => {
        if (reportDisplayType !== "cst") return;

        if (copyCST.current.length === 0 && user.current === null) {
            setFilteredParametrosCST([]);
            return;
        }

        let processedData = copyCST.current.filter(item => {
            if (user.current === null) return false;
            return tipo === "personal" ? item.user === user.current : item.user !== user.current;
        });

        processedData = aplicarFiltrosCST(processedData, filtrosAplicadosCST);

        if (busqueda) {
            const searchTerms = busqueda.toLowerCase().split(" ");
            processedData = processedData.filter(param => {
                if (typeof param !== "object" || param === null) return false;
                return Object.values(param).some(value => {
                    if (value === null || value === undefined) return false;
                    const stringValue = String(value).toLowerCase();
                    return searchTerms.every(term => stringValue.includes(term));
                });
            });
        }

        processedData = sortDataCST(processedData, sortConfigCST);

        setFilteredParametrosCST(processedData);

    }, [busqueda, filtrosAplicadosCST, tipo, sortConfigCST, user.current, reportDisplayType, copyCST.current]);

    // MODIFICACIÓN 3: useEffect corregido para la lista Express
    useEffect(() => {
        if (reportDisplayType !== "express" || !isExpressDataReady) return;

        if (!copyExpress || user.current === null) {
            setFilteredParametrosExpress([]);
            return;
        }

        let currentData = copyExpress.filter(item => {
            return tipo === "personal" ? item.user === user.current : item.user !== user.current;
        });

        if (busqueda) {
            const lowerBusqueda = busqueda.toLowerCase();
            currentData = currentData.filter(group => {
                return (
                    String(group.negativeType).toLowerCase().includes(lowerBusqueda) ||
                    String(group.customerSearchTerms).toLowerCase().includes(lowerBusqueda) ||
                    String(group.createdAt).toLowerCase().includes(lowerBusqueda) ||
                    String(group.updatedAt).toLowerCase().includes(lowerBusqueda) ||
                    String(group.destination).toLowerCase().includes(lowerBusqueda)
                );
            });
        }
        currentData = sortExpressData(currentData, sortConfigExpress);
        setFilteredParametrosExpress(currentData);
    }, [isExpressDataReady, tipo, busqueda, sortConfigExpress, reportDisplayType, user.current, copyExpress]);

    return (
        <Layout>
            <div className="app-container1">
                <div className="content-containerParametros px-5 py-4">
                    <div className="">
                        <h2 className="mb-4 text-center">
                            BLACKLIST
                        </h2>

                        <div className="d-flex justify-content-center mb-3 gap-4">
                            <h5
                                className={`report-type-label ${reportDisplayType === "cst" ? "active-filter" : ""}`}
                                onClick={() => setReportDisplayType("cst")}
                                style={{ cursor: "pointer", margin: 0 }}
                            >
                                Lista Reporte
                            </h5>
                            <h5
                                className={`report-type-label ${reportDisplayType === "express" ? "active-filter" : ""}`}
                                onClick={() => setReportDisplayType("express")}
                                style={{ cursor: "pointer", margin: 0 }}
                            >
                                Lista Express
                            </h5>
                        </div>

                        <div className="d-flex justify-content-start mb-3 gap-3">
                            <span
                                className={`sub-tab-label ${tipo === "personal" ? "active-sub-tab" : ""}`}
                                onClick={() => setTipo("personal")}
                                style={{ cursor: "pointer" }}
                            >
                                Mis Términos
                            </span>
                            <span
                                className={`sub-tab-label ${tipo === "otros" ? "active-sub-tab" : ""}`}
                                onClick={() => setTipo("otros")}
                                style={{ cursor: "pointer" }}
                            >
                                Otros Términos
                            </span>
                        </div>

                        <div className="d-flex flex-wrap align-items-center justify-content-between mb-4 gap-3">
                            <input
                                type="text"
                                placeholder="Buscar..."
                                value={busqueda}
                                onChange={(e) => setBusqueda(e.target.value)}
                                className="form-control"
                                style={{ maxWidth: "400px", flexGrow: 1 }}
                            />
                            {reportDisplayType === "cst" && (
                                <div style={{ minWidth: "250px" }}>
                                    <Select
                                        options={opcionesFiltradoCST}
                                        placeholder="Filtrar por..."
                                        isSearchable
                                        onChange={handleSelectChangeCST}
                                        styles={{
                                            control: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: "#ffeeba",
                                                border: "1px solid #e0a800",
                                                boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(255, 193, 7, 0.25)" : null,
                                                "&:hover": {
                                                    borderColor: "#e0a800"
                                                }
                                            }),
                                            valueContainer: (provided) => ({
                                                ...provided,
                                                color: "#212529"
                                            }),
                                            singleValue: (provided) => ({
                                                ...provided,
                                                color: "#212529"
                                            }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isSelected ? "#ffeeba" : "#fff",
                                                color: state.isSelected ? "#000" : "#212529"
                                            })
                                        }}
                                    />
                                </div>
                            )}
                            {reportDisplayType === "express" && (
                                <div style={{ minWidth: "250px", visibility: "hidden" }} aria-hidden="true">
                                </div>
                            )}
                        </div>

                        {reportDisplayType === "cst" && (
                            <div className="d-flex gap-2 flex-wrap my-3">
                                {Object.entries(filtrosAplicadosCST).map(([key, value]) => (
                                    <span key={key} className="badge bg-primary text-white d-flex align-items-center gap-2 px-3 py-2 rounded-pill">
                                        {
                                            typeof value === "object" && value !== null ? (
                                                value.hasOwnProperty("start") && value.hasOwnProperty("end") ? (
                                                    `${key}: ${value.start ? value.start.toLocaleDateString() : ""} - ${value.end ? value.end.toLocaleDateString() : ""}`
                                                ) : value.hasOwnProperty("option") && value.hasOwnProperty("value") ? (
                                                    `${key}: ${value.option} ${value.value}`
                                                ) : (
                                                    `${key}: ${value}`
                                                )
                                            ) : (
                                                `${key}: ${value}`
                                            )
                                        }
                                        <button
                                            className="btn btn-sm btn-light border-0"
                                            onClick={() => {
                                                const nuevo = { ...filtrosAplicadosCST };
                                                delete nuevo[key];
                                                setFiltrosAplicadosCST(nuevo);
                                            }}
                                            style={{ backgroundColor: "transparent", color: "white", fontSize: "1rem", padding: "0 5px", border: "none" }}
                                        >
                                            ✕
                                        </button>
                                    </span>
                                ))}
                            </div>
                        )}

                        {reportDisplayType === "cst" && (
                            <Modal style={{ zIndex: 10000 }} show={showModalCST} onHide={() => setShowModalCST(false)}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Filtrar por {modalTitleCST}</Modal.Title>
                                </Modal.Header>

                                <Modal.Body style={{ minHeight: "150px", height: "auto" }}>
                                    {modalTitleCST === "Report Date" ? (
                                        <>
                                            <label htmlFor="date-range-picker" className="date-range-label my-3">
                                                Seleccione un rango de fechas:
                                            </label>
                                            <div className="date-range-picker-container">
                                                <DatePicker
                                                    selectsRange
                                                    startDate={startDateCST}
                                                    endDate={endDateCST}
                                                    onChange={(update) => {
                                                        setDateRangeCST(update);
                                                    }}
                                                    isClearable={true}
                                                    dateFormat="yyyy-MM-dd"
                                                    className="form-control"
                                                    id="date-range-picker"
                                                    popperPlacement="bottom"
                                                    popperProps={{
                                                        positionFixed: true,
                                                        strategy: "fixed"
                                                    }}
                                                />
                                            </div>
                                        </>
                                    ) : modalTitleCST === "Negative Type" || modalTitleCST === "Negativization Mode" || modalTitleCST === "Section" ? (
                                        <select
                                            className="form-select"
                                            value={selectedOptionCST === null ? "" : selectedOptionCST}
                                            onChange={(e) => setSelectedOptionCST(e.target.value)}
                                        >
                                            <option value="">Seleccione una opción</option>
                                            {modalOptionsCST.map((opcion, i) => (
                                                <option key={i} value={opcion}>{opcion}</option>
                                            ))}
                                        </select>
                                    ) : modalTitleCST === "Customer Search Term" ? (
                                        <div>
                                            <select
                                                className="form-select mb-2"
                                                value={selectedOptionCST === null ? "" : selectedOptionCST}
                                                onChange={(e) => setSelectedOptionCST(e.target.value)}
                                            >
                                                <option value="">Seleccione una opción</option>
                                                <option value="Contiene">Contiene</option>
                                                <option value="No Contiene">No Contiene</option>
                                                <option value="Es igual a">Es igual a</option>
                                                <option value="No es igual a">No es igual a</option>
                                                <option value="Empieza por">Empieza por</option>
                                                <option value="Termina por">Termina por</option>
                                            </select>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={searchTermValueCST}
                                                onChange={(e) => setSearchTermValueCST(e.target.value)}
                                                placeholder="Ingrese el término de búsqueda"
                                            />
                                        </div>
                                    ) : null}
                                </Modal.Body>

                                <Modal.Footer>
                                    <Button variant="secondary" onClick={() => setShowModalCST(false)}>
                                        Cerrar
                                    </Button>
                                    <Button
                                        variant="primary"
                                        onClick={handleApplyFilterCST}
                                        disabled={
                                            modalTitleCST === "Report Date" ? !(startDateCST && endDateCST) :
                                                modalTitleCST === "Customer Search Term" ? !(selectedOptionCST && searchTermValueCST) :
                                                    !selectedOptionCST
                                        }
                                    >
                                        Aplicar
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        )}

                        {reportDisplayType === "cst" && (
                            <div className="table-responsive">
                                <table className="table table-striped table-hover tabla-parametros">
                                    <thead className="table-dark">
                                        <tr>
                                            <th className="text-center">View More</th>
                                            <th className="text-center" style={{ cursor: "pointer" }} onClick={() => handleSortCST("category")}>
                                                Type {sortConfigCST.key === "category" ? (sortConfigCST.direction === "asc" ? "▲" : "▼") : ""}
                                            </th>
                                            <th className="text-center" style={{ cursor: "pointer" }} onClick={() => handleSortCST("section")}>
                                                Section {sortConfigCST.key === "section" ? (sortConfigCST.direction === "asc" ? "▲" : "▼") : ""}
                                            </th>
                                            <th className="text-center" style={{ cursor: "pointer" }} onClick={() => handleSortCST("fecha")}>
                                                Report Date {sortConfigCST.key === "fecha" ? (sortConfigCST.direction === "asc" ? "▲" : "▼") : ""}
                                            </th>
                                            <th className="text-center" style={{ cursor: "pointer" }} onClick={() => handleSortCST("nombre")}>
                                                Customer Search Term {sortConfigCST.key === "nombre" ? (sortConfigCST.direction === "asc" ? "▲" : "▼") : ""}
                                            </th>
                                            <th className="text-center" style={{ cursor: "pointer" }} onClick={() => handleSortCST("negativizationMode")}>
                                                Negativization Mode {sortConfigCST.key === "negativizationMode" ? (sortConfigCST.direction === "asc" ? "▲" : "▼") : ""}
                                            </th>
                                            <th className="text-center" style={{ cursor: "pointer" }} onClick={() => handleSortCST("tipo")}>
                                                Negative Type {sortConfigCST.key === "tipo" ? (sortConfigCST.direction === "asc" ? "▲" : "▼") : ""}
                                            </th>
                                            <th className="text-center" style={{ cursor: "pointer" }} onClick={() => handleSortCST("dateNegativized")}>
                                                Date Negativized {sortConfigCST.key === "dateNegativized" ? (sortConfigCST.direction === "asc" ? "▲" : "▼") : ""}
                                            </th>
                                            <th className="text-center" style={{ cursor: "pointer" }} onClick={() => handleSortCST("dateUpdated")}>
                                                Date Updated {sortConfigCST.key === "dateUpdated" ? (sortConfigCST.direction === "asc" ? "▲" : "▼") : ""}
                                            </th>
                                            <th className="text-center">Archivar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredParametrosCST.length > 0 ? (
                                            filteredParametrosCST.map((param) => (
                                                <tr key={param.id}>
                                                    <td className="text-center">
                                                        <button
                                                            onClick={() => handleVerCST(param)}
                                                            className="btn btn-sm btn-info"
                                                            title="Ver detalles"
                                                        >
                                                            <FaEye />
                                                        </button>
                                                    </td>
                                                    <td className="text-center">{param.category}</td>
                                                    <td className={`text-center fw-bold ${param.section?.toLowerCase()}`}>
                                                        {param.section}
                                                    </td>
                                                    <td className="text-center">{param.fecha}</td>
                                                    <td className="text-center">{param.nombre}</td>
                                                    <td className="text-center">{param.negativizationMode}</td>
                                                    <td className="text-center">{param.tipo}</td>
                                                    <td className="text-center">{param.dateNegativized}</td>
                                                    <td className="text-center">{param.dateUpdated}</td>
                                                    <td className="text-center">
                                                        <div className="d-flex justify-content-center gap-2">
                                                            <button
                                                                onClick={() => handleArchiveCST(param)}
                                                                className="btn btn-sm btn-warning"
                                                                title="Archivar"
                                                                disabled={tipo === "otros"}
                                                            >
                                                                <FaArchive />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="9" className="text-center py-4">No hay reportes de Customer Search Term para mostrar.</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        {reportDisplayType === "express" && (
                            <>
                                <div className="table-responsive">
                                    <table className="table table-striped table-hover tabla-parametros">
                                        <thead className="table-dark">
                                            <tr>
                                                <th className="text-center">Ver detalles</th>
                                                <th className="text-center" style={{ cursor: "pointer" }} onClick={() => handleSortExpress("negativeType")}>
                                                    Negative Type {sortConfigExpress.key === "negativeType" ? (sortConfigExpress.direction === "asc" ? "▲" : "▼") : ""}
                                                </th>
                                                <th className="text-center" style={{ cursor: "pointer" }} onClick={() => handleSortExpress("customerSearchTerms")}>
                                                    Customer Search Terms {sortConfigExpress.key === "customerSearchTerms" ? (sortConfigExpress.direction === "asc" ? "▲" : "▼") : ""}
                                                </th>
                                                <th className="text-center" style={{ cursor: "pointer" }} onClick={() => handleSortExpress("createdAt")}>
                                                    Created {sortConfigExpress.key === "createdAt" ? (sortConfigExpress.direction === "asc" ? "▲" : "▼") : ""}
                                                </th>
                                                <th className="text-center" style={{ cursor: "pointer" }} onClick={() => handleSortExpress("updatedAt")}>
                                                    Updated {sortConfigExpress.key === "updatedAt" ? (sortConfigExpress.direction === "asc" ? "▲" : "▼") : ""}
                                                </th>
                                                <th className="text-center" style={{ cursor: "pointer" }} onClick={() => handleSortExpress("destination")}>
                                                    Destino {sortConfigExpress.key === "destination" ? (sortConfigExpress.direction === "asc" ? "▲" : "▼") : ""}
                                                </th>
                                                <th className="text-center">Archivar</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredParametrosExpress.length > 0 ? (
                                                filteredParametrosExpress.map(group => (
                                                    <tr key={group.term_id}>
                                                        <td className="text-center">
                                                            <button
                                                                onClick={() => handleVerMasExpress(group.groupData)}
                                                                className="btn btn-sm btn-info"
                                                                title="Ver más detalles"
                                                            >
                                                                <FaEye />
                                                            </button>
                                                        </td>
                                                        <td className="text-center">{group.negativeType}</td>
                                                        <td className="text-center">{group.customerSearchTerms}</td>
                                                        <td className="text-center">{group.createdAt}</td>
                                                        <td className="text-center">{group.updatedAt}</td>
                                                        <td className="text-center">{group.destination}</td>
                                                        <td className="text-center">
                                                            <div className="d-flex justify-content-center gap-2">
                                                                <button
                                                                    onClick={() => handleArchiveExpress(group)}
                                                                    className="btn btn-sm btn-warning"
                                                                    title="Archivar"
                                                                    disabled={tipo === "otros"}
                                                                >
                                                                    <FaArchive />
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="7" className="text-center py-4">No hay reportes de Negativizador Express para mostrar.</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                <Modal dialogClassName="modal-90w" style={{ zIndex: 10000 }} show={showModalExpress} onHide={() => setShowModalExpress(false)}>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Detalles del Grupo Express</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        {modalDataExpress.length > 0 ? (
                                            <div className="table-responsive">
                                                <table className="table table-bordered table-striped">
                                                    <thead className="bg-light">
                                                        <tr>
                                                            <th>CST</th>
                                                            <th>Negative Type</th>
                                                            <th>Created</th>
                                                            <th>Updated</th>
                                                            <th>Destino</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {modalDataExpress.map((item, index) => (
                                                            <tr key={index}>
                                                                <td>{item.keyword}</td>
                                                                <td>{item.negative_type_id === 1 ? "Negative Exact" : "Negative Phrase"}</td>
                                                                <td>{format(new Date(item.created_at), "yyyy-MM-dd HH:mm:ss", { locale: es })}</td>
                                                                <td>{format(new Date(item.updated_at), "yyyy-MM-dd HH:mm:ss", { locale: es })}</td>
                                                                <td>{
                                                                    {
                                                                        1: "Adgroups",
                                                                        2: "Campaigns",
                                                                        3: "Portafolios",
                                                                        4: "Asins"
                                                                    }[item.destination_id] || "No definido"
                                                                }
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        ) : (
                                            <p className="text-center">No hay detalles disponibles para este grupo.</p>
                                        )}
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={() => setShowModalExpress(false)}>
                                            Cerrar
                                        </Button>
                                    </Modal.Footer>
                                </Modal>

                                <Modal dialogClassName="modal-90w" style={{ zIndex: 10000 }} show={showArchiveGroupModalExpress} onHide={() => setShowArchiveGroupModalExpress(false)}>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Archivar Términos del Grupo Express</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        {archiveGroupModalDataExpress.length > 0 ? (
                                            <div className="table-responsive w-100">
                                                <table className="table table-bordered table-striped w-100">
                                                    <thead className="bg-light">
                                                        <tr>
                                                            <th>CST</th>
                                                            <th>Negative Type</th>
                                                            <th>Created</th>
                                                            <th>Updated</th>
                                                            <th>Destino</th>
                                                            <th>Archivar</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {archiveGroupModalDataExpress.map((item, index) => (
                                                            <tr key={item.id}>
                                                                <td>{item.keyword}</td>
                                                                <td>{item.negative_type_id === 1 ? "Negative Exact" : "Negative Phrase"}</td>
                                                                <td>{format(new Date(item.created_at), "yyyy-MM-dd HH:mm:ss", { locale: es })}</td>
                                                                <td>{format(new Date(item.updated_at), "yyyy-MM-dd HH:mm:ss", { locale: es })}</td>
                                                                <td>{
                                                                    {
                                                                        1: "Adgroups",
                                                                        2: "Campaigns",
                                                                        3: "Portafolios",
                                                                        4: "Asins"
                                                                    }[item.destination_id] || "No definido"
                                                                }
                                                                </td>
                                                                <td className="text-center">
                                                                    <button
                                                                        onClick={() => handleArchiveIndividualExpress(item)}
                                                                        className="btn btn-sm btn-warning"
                                                                        title="Archivar"
                                                                        disabled={tipo === "otros"}
                                                                    >
                                                                        <FaArchive />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        ) : (
                                            <p className="text-center">No hay términos en este grupo para archivar.</p>
                                        )}
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={() => setShowArchiveGroupModalExpress(false)}>
                                            Cerrar
                                        </Button>
                                    </Modal.Footer>
                                </Modal>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default Lista;